<template lang="pug">
div
  announcement
  .container
    .member-wrapper
      memberMenu
      template(v-if="accountGroup === 'WI'")
        depositWI
      template(v-else)
        depositMU
  //- seo
</template>

<script>
export default {
  components: {
    announcement: () => import("@/components/_announcement"),
    memberMenu: () => import("@/components/_memberMenu"),
    depositWI: () => import("@/components/transaction/_depositWI"),
    depositMU: () => import("@/components/transaction/_depositMU"),
    seo: () => import("@/components/_seo")
  },
  computed: {
    accountGroup() {
      return this.$store.getters.accountGroup
    }
  }
}
</script>